import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsGetFeelingLucky } from '../../../entity/interface/iThinkAnalytics';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';

export interface IGetFeelingLuckyUseCase {
    execute(
        apiKey: string,
        token: string,
        profileName: string,
        userName: string,
        device: string,
        country: string,
        subGuids: string,
        rating: string,
        isKidsMode: boolean
    ): Promise<IThinkAnalyticsGetFeelingLucky>;
}

export class GetFeelingLuckyUseCase implements IGetFeelingLuckyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get thinkAnalyticsRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        token: string,
        profileName: string,
        userName: string,
        device: string,
        country: string,
        subGuids: string,
        rating: string,
        isKidsMode: boolean
    ): Promise<IThinkAnalyticsGetFeelingLucky> {
        return this.thinkAnalyticsRepository.getFeelingLucky(
            apiKey,
            token,
            profileName,
            userName,
            device,
            country,
            subGuids,
            rating,
            isKidsMode
        );
    }
}
